import { useIntl } from 'react-intl';
import { IconCloudDownload } from '@rossum/ui/icons/tabler';
import { Stack, SvgIcon, Typography } from '@rossum/ui/material';
import { borderRadius } from '@rossum/ui/theme';

export const AttachmentDropOverlay = () => {
  const intl = useIntl();
  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      spacing={1}
      sx={{
        position: 'absolute',
        inset: 8,
        bgcolor: theme =>
          theme.palette.mode === 'dark'
            ? 'rgba(0, 0, 0, 0.5)'
            : 'rgba(255, 255, 255, 0.6)',
        backdropFilter: 'blur(6px)',
        WebkitBackdropFilter: 'blur(6px)',
        border: 2,
        borderStyle: 'dashed',
        borderColor: 'primary.main',
        borderRadius: borderRadius('m'),
        zIndex: 10,
      }}
    >
      <SvgIcon fontSize="xLarge" color="primary">
        <IconCloudDownload />
      </SvgIcon>
      <Typography color="primary">
        {intl.formatMessage({ id: 'features.chat.attachments.dropFilesHere' })}
      </Typography>
    </Stack>
  );
};
